
import { defineComponent } from 'vue';
import { useNodeCanvasStore } from '../store';

export default defineComponent({
  name: 'ServiceConnectionPromt',
  data() {
    return {
      ncStore: useNodeCanvasStore()
    };
  },
  methods: {
    exit() {
      this.ncStore.connectingServiceNode = undefined;
    },
    connectAsServer() {
      this.ncStore.connectingServiceNode?.service.removeServer();
      this.ncStore.connectingServiceNode?.service.addServer(
        this.ncStore.connectingServiceNode.node
      );
    },
    connectAsClient() {
      this.ncStore.connectingServiceNode?.service.addClient(
        this.ncStore.connectingServiceNode.node
      );
    },
    removeClient() {
      this.ncStore.connectingServiceNode?.service.removeClient(
        this.ncStore.connectingServiceNode.node
      );
    }
  }
});
